import React from "react"

import { TrialBlockProvider } from "@/contexts/TrialBlockContext"

import TrialBlocksContent from "./TrialBlocksContent"

export const TrialBlocksContentWithProvider: React.FC = () => {
  return (
    <TrialBlockProvider>
      <TrialBlocksContent />
    </TrialBlockProvider>
  )
}

export default TrialBlocksContentWithProvider
